// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"271c48f8","583":"e6be5c18"}[chunkId] + ".chunk.js";
};